import { Action, createAction, props } from '@ngrx/store';
import { HttpError, Membership } from '@rd/types';
import {
  CreateCashBackMembershipData,
  CreatePointsTransferMembershipData,
  UpdateCashBackMembershipData,
  UpdatePointsTransferMembershipData,
} from '../../services/membership-api/membership-api.service';

export enum MembershipActionTypes {
  LOAD_ALL_MEMBERSHIPS = '[Membership] Load all Memberships',
  LOAD_ALL_MEMBERSHIPS_SUCCESS = '[Membership] Load all Memberships Success',
  LOAD_ALL_MEMBERSHIPS_FAIL = '[Membership] Load all Memberships Fail',
  CREATE_MEMBERSHIP = '[Membership] Create Membership',
  CREATE_MEMBERSHIP_SUCCESS = '[Membership] Create Membership Success',
  CREATE_MEMBERSHIP_FAIL = '[Membership] Create Membership Fail',
  UPDATE_MEMBERSHIP = '[Membership] Update Membership',
  UPDATE_MEMBERSHIP_SUCCESS = '[Membership] Update Membership Success',
  UPDATE_MEMBERSHIP_FAIL = '[Membership] Update Membership Fail',
  CLEAR_CREATE_AND_UPDATE_MEMBERSHIP_ERRORS = '[Membership] Clear Create and Update Membership Errors',
}

export class LoadAllMemberships implements Action {
  readonly type = MembershipActionTypes.LOAD_ALL_MEMBERSHIPS;
}

export class LoadAllMembershipsSuccess implements Action {
  readonly type = MembershipActionTypes.LOAD_ALL_MEMBERSHIPS_SUCCESS;

  constructor(public payload: Membership[]) {}
}

export class LoadAllMembershipsFail implements Action {
  readonly type = MembershipActionTypes.LOAD_ALL_MEMBERSHIPS_FAIL;

  constructor(public payload: HttpError) {}
}

export class CreateMembership implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP;

  constructor(
    public payload:
      | CreateCashBackMembershipData
      | CreatePointsTransferMembershipData,
  ) {}
}

export class CreateMembershipSuccess implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS;

  constructor(public payload: Membership) {}
}

export class CreateMembershipFail implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP_FAIL;

  constructor(public payload: HttpError) {}
}

export class UpdateMembership implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP;

  constructor(
    public payload: {
      updateMembershipData:
        | UpdateCashBackMembershipData
        | UpdatePointsTransferMembershipData;
      isOverlapping?: true;
    },
  ) {}
}

export class UpdateMembershipSuccess implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS;

  constructor(public payload: Membership) {}
}

export class UpdateMembershipFail implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP_FAIL;

  constructor(public payload: HttpError) {}
}

export class ClearCreateAndUpdateCashBackMembershipErrors implements Action {
  readonly type =
    MembershipActionTypes.CLEAR_CREATE_AND_UPDATE_MEMBERSHIP_ERRORS;
}

export const linkMembership = createAction(
  '[Membership] Link Membership',
  props<{ loyaltyProgramId: string }>(),
);

export const linkMembershipFail = createAction(
  '[Membership] Link Membership Fail',
  props<{ error: HttpError }>(),
);

export const unlinkMembership = createAction(
  '[Membership] Unlink Membership',
  props<{ loyaltyProgramId: string }>(),
);

export const unlinkMembershipFail = createAction(
  '[Membership] Unlink Membership Fail',
  props<{ error: HttpError }>(),
);

export const redirectToProgramLinking = createAction(
  '[Membership] Redirect to Program Linking',
  props<{ url: string }>(),
);

export type MembershipActions =
  | LoadAllMemberships
  | LoadAllMembershipsSuccess
  | LoadAllMembershipsFail
  | CreateMembership
  | CreateMembershipSuccess
  | CreateMembershipFail
  | UpdateMembership
  | UpdateMembershipSuccess
  | UpdateMembershipFail
  | ClearCreateAndUpdateCashBackMembershipErrors
  | typeof linkMembership
  | typeof linkMembershipFail
  | typeof unlinkMembership
  | typeof unlinkMembershipFail
  | typeof redirectToProgramLinking;
